'use client'

import { WagmiProvider } from 'wagmi'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { createConfig, http } from 'wagmi'
import { base } from 'wagmi/chains'
import { farcasterFrame, farcasterMiniApp } from '@farcaster/frame-wagmi-connector'
import { metaMask, injected, walletConnect } from 'wagmi/connectors'
import { useState, useEffect } from 'react'

const projectId = process.env.NEXT_PUBLIC_WALLETCONNECT_PROJECT_ID || 'demo-project-id'


const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000, 
    },
  },
})

export function Providers({ children }: { children: React.ReactNode }) {
  const [config, setConfig] = useState<any>(null)
  const [mounted, setMounted] = useState(false)

  useEffect(() => {

    const wagmiConfig = createConfig({
      chains: [base],
      transports: {
        [base.id]: http(),
      },
      connectors: [
        farcasterMiniApp(),
        metaMask(),
        injected({ target: 'okxWallet' }),
        walletConnect({ projectId }),
      ],
    })
    
    setConfig(wagmiConfig)
    setMounted(true)
  }, [])


  if (!mounted || !config) {
    return (
      <div data-component-id="src/components/common/providers.tsx:48:6" data-component-path="src/components/common/providers.tsx" data-component-line="48" data-component-end-line="53" data-component-file="providers.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-center%20justify-center%20min-h-screen%20bg-black%20text-white%22%7D" className="flex items-center justify-center min-h-screen bg-black text-white">
        <div data-component-id="src/components/common/providers.tsx:49:8" data-component-path="src/components/common/providers.tsx" data-component-line="49" data-component-end-line="52" data-component-file="providers.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22text-center%22%7D" className="text-center">
          <div data-component-id="src/components/common/providers.tsx:50:10" data-component-path="src/components/common/providers.tsx" data-component-line="50" data-component-end-line="50" data-component-file="providers.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-12%20h-12%20border-4%20border-purple-600%20border-t-transparent%20rounded-full%20animate-spin%20mx-auto%20mb-4%22%7D" className="w-12 h-12 border-4 border-purple-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p data-component-id="src/components/common/providers.tsx:51:10" data-component-path="src/components/common/providers.tsx" data-component-line="51" data-component-end-line="51" data-component-file="providers.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-sm%20text-gray-400%22%2C%22textContent%22%3A%22Loading%20Web3%20Wingman...%22%7D" className="text-sm text-gray-400">Loading Web3 Wingman...</p>
        </div>
      </div>
    )
  }

  return (
    <WagmiProvider data-component-id="src/components/common/providers.tsx:58:4" data-component-path="src/components/common/providers.tsx" data-component-line="58" data-component-end-line="62" data-component-file="providers.tsx" data-component-name="WagmiProvider" data-component-content="%7B%22elementName%22%3A%22WagmiProvider%22%7D" config={config}>
      <QueryClientProvider data-component-id="src/components/common/providers.tsx:59:6" data-component-path="src/components/common/providers.tsx" data-component-line="59" data-component-end-line="61" data-component-file="providers.tsx" data-component-name="QueryClientProvider" data-component-content="%7B%22elementName%22%3A%22QueryClientProvider%22%7D" client={queryClient}>
        {children}
      </QueryClientProvider>
    </WagmiProvider>
  )
}